import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from 'dibs-elements/exports/Tooltip';

import { trackNewSellerPillHover } from '../tracking/newSellerPillTracking';

import styles from './PdpSharedNewSellerPill.scss';

export class PdpSharedNewSellerPill extends React.Component {
    constructor() {
        super();
        this.state = { isTooltipOpen: false };
    }

    showTooltip = () => {
        this.setState({ isTooltipOpen: true }, () => {
            trackNewSellerPillHover();
        });
    };

    hideTooltip = () => {
        this.setState({ isTooltipOpen: false });
    };

    render() {
        return (
            <span
                className={styles.container}
                onMouseEnter={this.showTooltip}
                onMouseLeave={this.hideTooltip}
                data-tn="pdp-new-seller-pill"
            >
                <span className={styles.text}>
                    <FormattedMessage
                        id="PdpSharedNewSellerPill.pill_text"
                        defaultMessage="New to 1stdibs"
                    />
                </span>
                <Tooltip isVisible={this.state.isTooltipOpen} direction="top" type="small">
                    <div className={styles.tooltipText}>
                        <FormattedMessage
                            id="PdpSharedNewSellerPill.tooltip"
                            defaultMessage="Joined in the past six months."
                        />
                    </div>
                </Tooltip>
            </span>
        );
    }
}
